import React, { useState } from 'react';
import "../styles/Contact.css";
import axios from 'axios';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMessage(null);

    const webhookURL = "https://discord.com/api/webhooks/1364294896059420672/8PPCPYi_U4mOGz41i71hQ6y5ipohQs5_AVPC7xBRJp4j1sms-c7AXMG5xGO2hBAcv3dE";

    const content = `
<@&1295428262721355937>  
📬 **Message From RixxyMC Website Contact Form**

**👤 Name:** ${formData.name}  
**📧 Email:** ${formData.email}  
**📞 Phone:** ${formData.phone || 'Not provided'}  
**💬 Message:**  
> ${formData.message}
`;

    try {
      await axios.post(webhookURL, {
        content: content,
      });

      setResponseMessage('✅ Message sent successfully!');
      setFormData({ name: '', email: '', phone: '', message: '' });
    } catch (error) {
      console.error("Discord webhook error:", error);
      setResponseMessage('❌ Failed to send message. Try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        <h2>Get in Touch</h2>
        <p>We'd love to hear from you. Drop a message and we'll get back to you!</p>

        <form onSubmit={handleSubmit} className="contact-form">
          <div className="input-group">
            <input
              type="text"
              name="name"
              placeholder=" "
              value={formData.name}
              onChange={handleChange}
              required
            />
            <label>Your Name</label>
          </div>
          <div className="input-group">
            <input
              type="email"
              name="email"
              placeholder=" "
              value={formData.email}
              onChange={handleChange}
              required
            />
            <label>Your Email</label>
          </div>
          <div className="input-group">
            <input
              type="text"
              name="phone"
              placeholder=" "
              value={formData.phone}
              onChange={handleChange}
            />
            <label>Phone Number (Optional)</label>
          </div>
          <div className="input-group">
            <textarea
              name="message"
              placeholder=" "
              value={formData.message}
              onChange={handleChange}
              required
            />
            <label>Your Message</label>
          </div>
          <button type="submit" disabled={loading} className="submit-button">
            {loading ? 'Sending...' : 'Send Message'}
          </button>
        </form>

        {responseMessage && (
          <p
            className={`response-message ${
              responseMessage.includes('success')
                ? 'success-message'
                : 'error-message'
            }`}
          >
            {responseMessage}
          </p>
        )}
      </div>
    </div>
  );
};

export default Contact;
